'use client';

import { EditorEntry } from '@/components/studio/editor/EditorEntry';

export default function StudioEditorPage() {
  return <EditorEntry />;
}
